import { createFileRoute } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../app/guards'
import { TaskCalendarPage } from '../../features/tasks/calendar-page'
import { calendarSearchSchema } from '../../features/tasks/search'

// The task calendar (ADR-021, TASKS.md §7), while the company has the module.
export const Route = createFileRoute('/_app/calendar')({
  staticData: { crumb: 'calendar' },
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'tasks')
    requirePermission(context.session, 'tasks.read')
  },
  validateSearch: calendarSearchSchema,
  component: TaskCalendarPage,
})
